import Utils from '../../../scripts/utils';
import Stars from '../../../components/Stars';
import SoundFx from '../../../components/SoundFx';
import {gtag} from '../../../components/Analytics';

import PuzzleData from './PuzzleData';
import generateInitialState from './PuzzleUtils/generate-initial-state';
import buildPuzzle from './PuzzleUtils/build-puzzle';

const SECRET_STRING =
  'Rm9yIGV2ZXJ5IGFjdGlvbiwgdGhlcmUgaXMgYW4gZXF1YWwgYW5kIG9wcG9zaXRlIHJlYWN0aW9uLg==';
const solvedTrackClasses = ['track-0-solved', 'track-1-solved', 'track-2-solved', 'track-3-solved'];
const solvedHeroClass = 'Hero--isCompleted';
const Classes = {
  sectionLoading: 'Section--isLoading',
  containerHero: 'CubesFrame--idHero',
};

export default class HeroPuzzle {
  constructor(node) {
    this.node = node;
    this.container = node.querySelector(`.${Classes.containerHero}`);
    this.progress = generateInitialState();
    this.cubes = null;
    this.tracks = null;
    this.solved = false;

    this._successEvent = this._successEvent.bind(this);
    this._checkFaces = this._checkFaces.bind(this);
    this._checkTracks = this._checkTracks.bind(this);
  }

  static getParentCube(progress, expectedFace, idFace) {
    let result = null;

    progress.forEach((cube, index) => {
      for (const face in cube) {
        if (Object.prototype.hasOwnProperty.call(cube, face)) {
          if (face === expectedFace) {
            const faceKey = Object.keys(cube[face])[0];

            if (faceKey === idFace) {
              result = index;
            }
          }
        }
      }
    });

    return result;
  }

  static getSwapData(progress, source, swapped) {
    const face = source.getAttribute('data-face');
    const idSource = source.id;
    const idSwapped = swapped.id;

    return {
      face,
      source: {
        id: idSource,
        originalCube: HeroPuzzle.getParentCube(progress, face, idSource),
      },
      swapped: {
        id: idSwapped,
        originalCube: HeroPuzzle.getParentCube(progress, face, idSwapped),
      },
    };
  }

  static isIdentical(faceObj, expectedObj) {
    const equalPieces = faceObj.piece === expectedObj.piece;
    const equalAngles = faceObj.angle === expectedObj.angle;

    return equalPieces && equalAngles;
  }

  // --- Public --- //

  init() {
    this.container.appendChild(buildPuzzle(this.progress));
    this.cubes = this.container.children;
    this.node.classList.remove(Classes.sectionLoading);
    this.checkSolutions(null);
  }

  updateProgress(swapData) {
    const sourceCube = swapData.source.originalCube;
    const swappedCube = swapData.swapped.originalCube;

    const sourceData = this.progress[sourceCube][swapData.face];
    const swappedData = this.progress[swappedCube][swapData.face];

    this.progress[sourceCube][swapData.face] = swappedData;
    this.progress[swappedCube][swapData.face] = sourceData;
  }

  checkSolutions(draggableInstance) {
    // reset tracks before beginning
    this.tracks = [0, 0, 0, 0];

    // now check the placement of each face,
    // followed by tallying up the correct faces within a track
    this.progress.forEach(this._checkFaces);
    this.tracks.forEach(this._checkTracks);

    if (Utils.arrayContainsArray(this.tracks, PuzzleData.Tracks)) {
      this._successEvent(draggableInstance);
    }
  }

  // --- Private --- //
  _sendAnalytics() {
    // This method relies on the `app.js` instantiation of Analytics to have worked correctly,
    // which is why I reassign `dataLayer` – in case `appendScript` failed.
    // In the event Analytics didn't execute successfully, the `gtag` arguments will get pushed
    // without error, but the event won't actually get send to Google.
    window.dataLayer = window.dataLayer || [];

    /* eslint-disable babel/camelcase */
    gtag('event', 'puzzle_solved', {
      event_category: 'Hero puzzle',
      event_label: 'Solved the hero puzzle',
      transport_type: 'beacon',
      event_callback: () => {
        // Won't fire in local development because Analytics is not initialized
        console.log(SECRET_STRING);
      },
    });
    /* eslint-enable babel/camelcase */
  }

  _successEvent(draggableInstance) {
    draggableInstance.destroy();

    this.solved = true;
    this.node.classList.add(solvedHeroClass);
    this.node.appendChild(Stars());
    SoundFx.Single.play('heroSuccess');

    this._sendAnalytics();
  }

  _checkFaces(cube, index) {
    for (const face in cube) {
      if (Object.prototype.hasOwnProperty.call(cube, face)) {
        const faceKey = Object.keys(cube[face])[0];
        const faceObj = cube[face][faceKey];
        const expectedKey = PuzzleData.Cubes[index][face].face;
        const expectedObj = PuzzleData.Faces[face][expectedKey];

        if (faceKey === expectedKey || HeroPuzzle.isIdentical(faceObj, expectedObj)) {
          this.tracks[expectedObj.track]++;
        }
      }
    }
  }

  _checkTracks(_item, index) {
    const trackIsEqual = this.tracks[index] === PuzzleData.Tracks[index];
    const hasSuccessClass = this.container.classList.contains(solvedTrackClasses[index]);

    if (trackIsEqual && hasSuccessClass === false) {
      SoundFx.Synth.play('powerOn');
      this.container.classList.add(solvedTrackClasses[index]);
    } else if (trackIsEqual === false && hasSuccessClass) {
      SoundFx.Synth.play('powerOff');
      this.container.classList.remove(solvedTrackClasses[index]);
    }
  }
}
